export default class PointForm {
  constructor(data = {}) {
    this.name = data.name || null
    this.description = data.description || null
    this.point = data.point || 1
    this.validFrom = data.validFromStr || null
    this.validTo = data.validToStr || null
  }

  static validator() {
    return {
      name: 'required|min:3|max:255',
      description: 'required|min:3',
      point: 'required|numeric|min:1',
      validFrom: 'required|date_format:yyyy-MM-dd',
      validTo: 'required|date_format:yyyy-MM-dd',
    }
  }
}
